import { PepType as PepTypeVariant } from '@marketplace-web/pay-identity/politically-exposed-person-data'
import { NationalityCountryModel } from '@marketplace-web/nationality-select/nationality-select-data'
import { AddressModel } from '@marketplace-web/address/address-data'

export enum Field {
  FullName = 'fullName',
  FirstName = 'firstName',
  LastName = 'lastName',
  Birthdate = 'birthdate',
  SsnNumber = 'ssn',
  PersonalIdNumber = 'personalIdNumber',
  Nationality = 'nationality',
  Address = 'address',
  PepType = 'pepType',
  PepFullName = 'pepFullName',
  PepPosition = 'pepPosition',
  PepOrganisation = 'pepOrganisation',
  PepPositionDate = 'pepPositionDate',
}

export type FormModel = {
  [Field.FirstName]: string
  [Field.LastName]: string
  [Field.Birthdate]: string
  [Field.Address]?: AddressModel | null
  [Field.SsnNumber]: string
  [Field.PersonalIdNumber]: string
  [Field.Nationality]: NationalityCountryModel | null
  [Field.PepType]?: PepTypeVariant
  [Field.PepFullName]?: string
  [Field.PepPosition]?: string
  [Field.PepOrganisation]?: string
  [Field.PepPositionDate]?: string
}

export type ActivateBalanceFormModel = {
  firstName: string
  lastName: string
  birthdate: string
  ssn: string
  personalIdNumber: string
  nationality: NationalityCountryModel | null
  pepType?: PepTypeVariant
  pepFullName?: string
  pepPosition?: string
  pepOrganisation?: string
  pepPositionDate?: string
}
